import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RouterSwitcher } from './root/routerSwitcher';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div>
      <RouterSwitcher />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover={false}
      />
    </div>
  );
}

export default App;
